import type { BiabConfig } from "./types";

declare global {
  interface Window {
    __biabConfig?: Partial<BiabConfig>;
  }
}

const FALLBACK: BiabConfig = {
  nonce: "",
  checkoutUrl: "/checkout",
};

export function getConfig(): BiabConfig {
  if (typeof window === "undefined") return FALLBACK;
  const injected = window.__biabConfig ?? {};
  return {
    nonce: injected.nonce ?? FALLBACK.nonce,
    checkoutUrl: injected.checkoutUrl ?? FALLBACK.checkoutUrl,
  };
}
